<div class="agenda-detailed-view">
  <infl-agenda-detailed-header
    [resources]="agendaDetailedService.groups"
    [resourceWidth]="resourceWidth()"
    [paginationStep]="paginationStep()"
    [currentPage]="currentPage()"
    (scrollLeftAction)="onScrollHeader($event)"
  />
  <div class="agenda-detailed-content">
    <cdk-virtual-scroll-viewport
      itemSize="{{fullRender() ? 0 : agendaDetailedService.rowHeight}}"
      [orientation]="'vertical'"
      [style.height]="'calc(100vh - 40px - 40px - 55px)'"
      (scroll)="onScrollResources($event)"
    >
      <div
        *cdkVirtualFor="let row of agendaDetailedService.rows"
        class="agenda-detailed-row"
      >
        <infl-agenda-detailed-row
          [row]="row"
          [resourceWidth]="resourceWidth()"
          [outsideDraggingTask]="outsideDraggingTask()"
          [currentPage]="currentPage()"
          [pageStep]="paginationStep()"
          (periodHovered)="periodHovered.emit($event)"
          (periodSelected)="periodSelected.emit($event)"
          (taskUpdate)="taskUpdate.emit($event)"
          (taskClick)="taskClick.emit($event)"
          (taskHover)="taskHover.emit($event)"
          (taskCreation)="taskCreation.emit($event)"
        ></infl-agenda-detailed-row>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>
